import React from 'react'
import List from '../components/List'
import hipladeTemplate from '../../common/template'

function EntitiesList() {
  return <List />
}

export default hipladeTemplate(EntitiesList)
